export default () => ({
  container: {
    width: "100%",
    margin: "0 auto 100px auto",
    padding: "0px 85px",
  },
  gridContainer: {
    display: "flex",
    gap: "0",
    marginTop: "36px",
  },
  column: {
    flex: 1,
    paddingRight: "38px",
  },
  columnRight: {
    flex: 1,
    paddingLeft: "42px",
  },
  divider: {
    width: "1px",
    backgroundColor: "#000000",
    alignSelf: "stretch",
  },
  card: {
    width: "100%",
    maxWidth: "780px",
    minHeight: "299px",
    borderBottom: "1px solid #C9C9C9",
    boxSizing: "border-box",
    marginBottom: "45px",
  },
  cardTitle: {
    fontFamily: "Nunito",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "20px",
    letterSpacing: "0.2px",
    color: "#000000",
    marginBottom: "24px",
  },
  cardRow: {
    display: "flex",
    marginBottom: "20px",
    alignItems: "baseline",
  },
  cardLabel: {
    fontFamily: "Inter",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "23px",
    letterSpacing: "0.31%",
    textTransform: "uppercase",
    color: "#027DA7",
    minWidth: "230px",
    width: "230px",
    flexShrink: 0,
  },
  cardValue: {
    fontFamily: "Nunito",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "23px",
    letterSpacing: "0.2px",
    color: "#000000",
  },
  cardLink: {
    color: "#990099",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  externalIcon: {
    width: "12px",
    height: "12px",
    marginLeft: "4px",
    verticalAlign: "middle",
  },
  noDataMessage: {
    fontFamily: "Nunito",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "22px",
    color: "#000000",
    padding: "20px 0",
  },
});
